import React from 'react'
// components
import GroupSecurity from 'components/PageComponents/Settings/Security/components/GroupSecurity'
import GroupSecurityAPI from 'containers/Security/components/GroupSecurity/layers/API'

const GroupSecurityContainer: React.FC = () => {
  return (
    <GroupSecurityAPI>
      <GroupSecurity />
    </GroupSecurityAPI>
  )
}

export default GroupSecurityContainer
